import { useContext } from 'react';

import { Context } from './SelfTestContext';

export function useSelfTest() {
  return useContext(Context);
}
